module.exports = __webpack_public_path__ + "static/portfolio-1-c341e807cbaebc48553907b6173dadd4.jpg";